export default __webpack_public_path__ + "static/media/hero-kayak.95d45f75.png";